const angular = require('angular')
require('js/services/module')

/* Filters */

angular.module('hxphone.filters', ['hxphone.services'])
  .filter('email', ['$utils', function ($utils) {
    /**
     * 解析多个email地址
     * @param text
     * @param tp    类型，支持name, addr, full三种类型，默认为name
     * @param sep   分隔符，默认为半角逗号
     */
    return function (text, tp, sep) {
      const type = $utils.$html.typeOf(text)
      if (type === 'undefined' || type === 'null' || type === '') {
        return text
      }
      tp = tp || 'name'
      sep = sep || ','

      const emails = type === 'array' ? text : (type === 'string' ? $utils.$email.parseList(text, false) : [])
      let result = ''
      if (tp === 'name') {
        angular.forEach(emails, function (email) {
          if (typeof email === 'string') {
            let temp = {}
            temp = $utils.$email.parse(email)
            temp.name = temp.name || $utils.$email.parseTrueName(email)
            email = temp
          }
          result += $utils.$html.trim(email.name || email.addr) + sep
        })
      } else if (tp === 'addr') {
        angular.forEach(emails, function (email) {
          if (typeof email === 'string') {
            email = $utils.$email.parse(email)
          }
          result += $utils.$html.trim(email.addr) + sep
        })
      } else {
        angular.forEach(emails, function (email) {
          // 去除联系人字符串trueName的引号
          result += $utils.$html.trim(email.addr).replace(/^"(.+)"/, (_, matched) => matched) + sep
        })
      }
      return result.substring(0, result.length - sep.length)
    }
  }])
  .filter('iconTypeNum', ['$utils', function ($utils) {
    return function (fileName) {
      return $utils.$attachment.getIconType(fileName)
    }
  }])
  .filter('iconClass', ['$utils', function ($utils) {
    return function (fileName, contentType) {
      return $utils.$attachment.getIconClass(fileName, contentType)
    }
  }])
  .filter('formatSize', ['$utils', function ($utils) {
    return function (size) {
      return $utils.$size.format(size)
    }
  }])
// 格式化时间, 若非当天时间，则显示日期，否则显示时间
  .filter('simpleDate', ['$utils', '$translate', function ($utils, $translate) {
    return function (d) {
      if (d === undefined || d === null || d === '') {
        return ''
      }
      // IOS中,safari不支持YYYY-MM-DD的格式,可以转成YYYY/MM/DD的格式
      d = new Date(d.replace(/-/g, '/'))
      if ($utils.$date.isSameDate($utils.$date.getCurrentDate(), d)) {
        return $utils.$date.getTimeSimple(d)
      } else if ($utils.$date.isYesterday(d, $utils.$date.getCurrentDate())) {
        return $translate.instant('CA_YESTERDAY')
      } else if ($utils.$date.isTheDayBeforeYesterday(d, $utils.$date.getCurrentDate())) {
        return $translate.instant('CA_THE_DAY_BEFORE_YESTERDAY')
      } else if ($utils.$date.isSameYear($utils.$date.getCurrentDate(), d)) {
        return $utils.$date.getTextWithoutYear(d)
      } else {
        return $utils.$date.getTextSimple(d)
      }
    }
  }])
  .filter('fullDate', ['$utils', function ($utils) {
    return function (d) {
      if (d === undefined || d === null || d === '') {
        return d
      }

      return $utils.$date.getTextFull(d)
    }
  }])
  // html不要转义输出
  .filter('trustedHtml', ['$sce', '$utils', function ($sce, $utils) {
    return function (text) {
      return $sce.trustAsHtml($utils.$html.filterXSS(text))
    }
  }])
  .filter('filterXSS', ['$utils', function ($utils) {
    return function (text) {
      return $utils.$html.filterXSS(text)
    }
  }])
  // 截断num个字符，若使用字符常量方式引用此filter，需要对字符中的单双引号进行转义处理
  .filter('ellipsis', ['$log', '$document', function ($log, $document) {
    // 每英文字符的像素数
    const pxPerFont = 7.3

    /// <summary>截取字符串(支持中英文混合)</summary>
    function subString(str, len, hasDot) {
      let newLength = 0
      let newStr = ''
      const chineseRegex = /[^\x00-\xff]/g //eslint-disable-line
      let singleChar = ''
      const strLength = str.replace(chineseRegex, '**').length
      for (let i = 0; i < strLength; i++) {
        singleChar = str.charAt(i).toString()
        if (singleChar.match(chineseRegex) != null) {
          newLength += 2
        } else {
          newLength++
        }
        if (newLength > len) {
          break
        }
        newStr += singleChar
      }

      if (hasDot && strLength > len) {
        newStr += '...'
      }
      return newStr
    }

    /**
     * @param num 应当返回多少长度的字符（英文为1，中文为2）
     *              若不指定num，则默认返回适应屏幕长度的字符数
     * @param offsetX 不指定num时有效，返回的字符串在屏幕的长度 约等于 屏幕长度 - offsetX
     */
    return function (text, num, offsetX) {
      offsetX = offsetX || 0

      if (text === undefined || text === null || text === '' ||
                (typeof text !== 'string')) {
        return text
      }

      text = text || ''
      // 每行应该出现多少个字符
      num = num || Math.floor(($document[0].body.clientWidth - offsetX) / pxPerFont)
      text = subString(text, num, true)
      return text
    }
  }])
// 去除重复项
  .filter('unique', function () {
    return function (items, filterOn) {
      if (filterOn === false) {
        return items
      }

      if ((filterOn || angular.isUndefined(filterOn)) && angular.isArray(items)) {
        const newItems = []

        const extractValueToCompare = function (item) {
          if (angular.isObject(item) && angular.isString(filterOn)) {
            return item[filterOn]
          } else {
            return item
          }
        }

        angular.forEach(items, function (item) {
          let isDuplicate = false

          for (let i = 0; i < newItems.length; i++) {
            if (angular.equals(extractValueToCompare(newItems[i]), extractValueToCompare(item))) {
              isDuplicate = true
              break
            }
          }
          if (!isDuplicate) {
            newItems.push(item)
          }
        })
        items = newItems
      }
      return items
    }
  })
  .filter('mailStateIcon', function () {
    return function (flags) {
      let icon = ''
      if (flags.forwarded && flags.replied) {
        icon = 'iconreplyforward'
      } else if (flags.forwarded) {
        icon = 'iconforwardsmall'
      } else if (flags.replied) {
        icon = 'iconreplysmall'
      }
      if (icon) {
        return 'icon-' + icon
      }
    }
  }).filter('resizeSubject', ['$utils', function ($utils) {
    return function (mail) {
      let icon = ''
      const flags = mail.flags

      if (flags.flagged) {
        icon = 'has-flagged'
      }
      if (flags.forwarded || flags.replied) {
        icon += ' has-iconforwardsmall'
      }

      if (!$utils.$date.isSameYear($utils.$date.getCurrentDate(), new Date(mail.sentDate.replace(/-/g, '/')))) {
        icon += ' has-year-text'
      }

      if (icon) {
        return icon
      }
    }
  }])



// WEBPACK FOOTER //
// ./src/js/filters/module.js